import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw--mx-5 tw--my-4 tw-bg-slate-50 tw-p-5" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-10"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tw-space-y-4" }
const _hoisted_5 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-px-4 tw-py-3 sm:tw-px-5" }
const _hoisted_6 = { class: "tw-min-w-0" }
const _hoisted_7 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_8 = { class: "tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-slate-900" }
const _hoisted_9 = {
  key: 1,
  class: "tw-flex tw-flex-wrap tw-items-end tw-gap-2"
}
const _hoisted_10 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_11 = { class: "tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-100 tw-p-1" }
const _hoisted_12 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4 sm:tw-p-5" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "tw-space-y-4" }
const _hoisted_15 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-3" }
const _hoisted_16 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { class: "tw-mt-4 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4" }
const _hoisted_19 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-slate-50 tw-p-3" }
const _hoisted_20 = {
  key: 0,
  class: "tw-mt-2 tw-flex tw-flex-wrap tw-items-end tw-gap-2"
}
const _hoisted_21 = {
  key: 1,
  class: "tw-mt-2"
}
const _hoisted_22 = {
  key: 0,
  class: "tw-text-sm tw-font-medium tw-text-slate-900"
}
const _hoisted_23 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_24 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-slate-50 tw-p-3" }
const _hoisted_25 = {
  key: 0,
  class: "tw-mt-2 tw-flex tw-flex-wrap tw-items-end tw-gap-2"
}
const _hoisted_26 = {
  key: 1,
  class: "tw-mt-2"
}
const _hoisted_27 = {
  key: 0,
  class: "tw-text-sm tw-font-medium tw-text-slate-900"
}
const _hoisted_28 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_29 = { class: "tw-mt-4 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4" }
const _hoisted_30 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_31 = { class: "tw-mt-3" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_34 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-gap-2" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_39 = { class: "tw-mt-3" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_42 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-gap-2" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GoogleAddressInput = _resolveComponent("GoogleAddressInput")!
  const _component_AddressBlock = _resolveComponent("AddressBlock")!
  const _component_CustomerContainers = _resolveComponent("CustomerContainers")!
  const _component_CustomerRates = _resolveComponent("CustomerRates")!
  const _component_CustomerContacts = _resolveComponent("CustomerContacts")!
  const _component_AddNotesArea = _resolveComponent("AddNotesArea")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: "customer-details-modal",
    title: _ctx.customer ? _ctx.customer.name : 'Customer',
    subtitle: "Customer details, contacts, notes, and rates.",
    maxWidth: "6xl",
    onClose: _ctx.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.$apollo.queries.customer.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                icon: "circle-notch",
                spin: "",
                class: "tw-h-8 tw-w-8 tw-text-slate-500"
              })
            ]))
          : (_ctx.customer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (!_ctx.isEditingName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.customer.name), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-2.5 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editName && _ctx.editName(...args)))
                            }, " Edit ")
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_InputField, {
                              class: "tw-w-[320px]",
                              id: "CustomerName",
                              label: "Customer Name",
                              modelValue: _ctx.tempCustomerName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempCustomerName) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_Button, {
                              isGreen: true,
                              isPrimary: true,
                              class: "tw-p-0",
                              icon: "check",
                              onClick: _ctx.saveCustomerName,
                              title: "Save customer name",
                              "aria-label": "Save customer name"
                            }, {
                              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                _createTextVNode(" Save ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_Button, {
                              isRed: true,
                              isSecondary: true,
                              class: "tw-p-0",
                              onClick: _ctx.cancelEditName,
                              title: "Cancel customer name edit",
                              "aria-label": "Cancel customer name edit"
                            }, {
                              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                _createTextVNode(" Cancel ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-500 focus-visible:tw-ring-offset-2", _ctx.activeTab === 'overview'
                      ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
                      : 'tw-text-slate-600 hover:tw-text-slate-900']),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'overview'))
                        }, " Overview ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-500 focus-visible:tw-ring-offset-2", _ctx.activeTab === 'containers'
                      ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
                      : 'tw-text-slate-600 hover:tw-text-slate-900']),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'containers'))
                        }, " Containers ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-500 focus-visible:tw-ring-offset-2", _ctx.activeTab === 'rates'
                      ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
                      : 'tw-text-slate-600 hover:tw-text-slate-900']),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'rates'))
                        }, " Rates & Billing ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-500 focus-visible:tw-ring-offset-2", _ctx.activeTab === 'contacts'
                      ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
                      : 'tw-text-slate-600 hover:tw-text-slate-900']),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'contacts'))
                        }, " Contacts ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-500 focus-visible:tw-ring-offset-2", _ctx.activeTab === 'notes'
                      ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
                      : 'tw-text-slate-600 hover:tw-text-slate-900']),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = 'notes'))
                        }, " Notes ", 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.activeTab === 'overview')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Account Details", -1)),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("label", _hoisted_16, [
                                _createElementVNode("input", {
                                  class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300",
                                  type: "checkbox",
                                  checked: _ctx.customer.isActive,
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleCustomerActive($event)))
                                }, null, 40, _hoisted_17),
                                _cache[30] || (_cache[30] = _createTextVNode(" Active ", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Display name", -1)),
                                (_ctx.isEditingDisplayName)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createVNode(_component_InputField, {
                                        id: "customerDisplayName",
                                        label: "Display Name",
                                        class: "tw-w-[320px]",
                                        modelValue: _ctx.tempDisplayName,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tempDisplayName) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_Button, {
                                        isGreen: true,
                                        isPrimary: true,
                                        class: "tw-p-0",
                                        icon: "check",
                                        type: "button",
                                        onClick: _ctx.saveDisplayName,
                                        title: "Save display name",
                                        "aria-label": "Save display name"
                                      }, {
                                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                          _createTextVNode(" Save ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_component_Button, {
                                        isRed: true,
                                        isSecondary: true,
                                        class: "tw-p-0",
                                        type: "button",
                                        onClick: _ctx.cancelDisplayNameEdit,
                                        title: "Cancel display name edit",
                                        "aria-label": "Cancel display name edit"
                                      }, {
                                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                          _createTextVNode(" Cancel ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      (_ctx.customer.displayName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.customer.displayName), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_23, "—")),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.editDisplayName && _ctx.editDisplayName(...args)))
                                      }, _toDisplayString(_ctx.customer.displayName ? 'Edit display name' : 'Add display name'), 1)
                                    ]))
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Contact email", -1)),
                                (_ctx.isEditingEmail)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createVNode(_component_InputField, {
                                        id: "customerContactEmail",
                                        label: "Email",
                                        class: "tw-w-[320px]",
                                        modelValue: _ctx.contactEmail,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contactEmail) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_Button, {
                                        isGreen: true,
                                        isPrimary: true,
                                        class: "tw-p-0",
                                        icon: "check",
                                        type: "button",
                                        onClick: _ctx.saveContactEmail,
                                        title: "Save contact email",
                                        "aria-label": "Save contact email"
                                      }, {
                                        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                          _createTextVNode(" Save ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_component_Button, {
                                        isRed: true,
                                        isSecondary: true,
                                        class: "tw-p-0",
                                        type: "button",
                                        onClick: _ctx.cancelEditEmail,
                                        title: "Cancel contact email edit",
                                        "aria-label": "Cancel contact email edit"
                                      }, {
                                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                          _createTextVNode(" Cancel ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_ctx.customer.contactEmail)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.customer.contactEmail), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_28, "—")),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.editEmail && _ctx.editEmail(...args)))
                                      }, _toDisplayString(_ctx.customer.contactEmail ? 'Edit contact email' : 'Add contact email'), 1)
                                    ]))
                              ])
                            ]),
                            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "tw-mt-4" }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Delivery Address", -1)),
                              _createElementVNode("div", _hoisted_31, [
                                (_ctx.isEditingAddress)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_GoogleAddressInput, {
                                          id: "streetAddReceiving",
                                          label: "Street Address",
                                          class: "sm:tw-col-span-2",
                                          modelValue: _ctx.editingCustomer.streetAddress,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingCustomer.streetAddress) = $event)),
                                          onAddressSelected: _ctx.handleAddressSelection
                                        }, null, 8, ["modelValue", "onAddressSelected"]),
                                        _createVNode(_component_InputField, {
                                          id: "suitNumberReceiving",
                                          label: "Suite #",
                                          modelValue: _ctx.editingCustomer.suite,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingCustomer.suite) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "cityReceiving",
                                          label: "City",
                                          modelValue: _ctx.editingCustomer.city,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingCustomer.city) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "stateReceiving",
                                          label: "State",
                                          modelValue: _ctx.editingCustomer.state,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingCustomer.state) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "zipReceiving",
                                          label: "Zip",
                                          modelValue: _ctx.editingCustomer.zipCode,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editingCustomer.zipCode) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_34, [
                                        _createVNode(_component_Button, {
                                          isGreen: true,
                                          isPrimary: true,
                                          class: "tw-p-0",
                                          icon: "check",
                                          type: "button",
                                          onClick: _ctx.saveAddress,
                                          title: "Save delivery address",
                                          "aria-label": "Save delivery address"
                                        }, {
                                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                            _createTextVNode(" Save ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_Button, {
                                          isRed: true,
                                          isSecondary: true,
                                          class: "tw-p-0",
                                          type: "button",
                                          onClick: _ctx.cancelAddressEdit,
                                          title: "Cancel delivery address edit",
                                          "aria-label": "Cancel delivery address edit"
                                        }, {
                                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                            _createTextVNode(" Cancel ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-rose-200 tw-bg-rose-50 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-rose-900 hover:tw-bg-rose-100",
                                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.deleteDeliveryAddress && _ctx.deleteDeliveryAddress(...args)))
                                        }, " Remove Address ")
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      (_ctx.address)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _createVNode(_component_AddressBlock, {
                                              name: _ctx.customer.name,
                                              address: _ctx.customer.deliveryAddress
                                            }, null, 8, ["name", "address"]),
                                            _createElementVNode("button", {
                                              class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                              type: "button",
                                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.startAddressEdit && _ctx.startAddressEdit(...args)))
                                            }, " Edit Address ")
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "No address on file.", -1)),
                                            _createElementVNode("button", {
                                              class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                              type: "button",
                                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.startAddressEdit && _ctx.startAddressEdit(...args)))
                                            }, " Add Address ")
                                          ]))
                                    ]))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Billing Address", -1)),
                              _createElementVNode("div", _hoisted_39, [
                                (_ctx.isEditingBillingAddress)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_GoogleAddressInput, {
                                          id: "billingStreet",
                                          label: "Street Address",
                                          class: "sm:tw-col-span-2",
                                          modelValue: _ctx.editingCustomer.streetAddress,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editingCustomer.streetAddress) = $event)),
                                          onAddressSelected: _ctx.handleAddressSelection
                                        }, null, 8, ["modelValue", "onAddressSelected"]),
                                        _createVNode(_component_InputField, {
                                          id: "billingSuite",
                                          label: "Suite #",
                                          modelValue: _ctx.editingCustomer.suite,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editingCustomer.suite) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "billingCity",
                                          label: "City",
                                          modelValue: _ctx.editingCustomer.city,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editingCustomer.city) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "billingState",
                                          label: "State",
                                          modelValue: _ctx.editingCustomer.state,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editingCustomer.state) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_InputField, {
                                          id: "billingZip",
                                          label: "Zip",
                                          modelValue: _ctx.editingCustomer.zipCode,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editingCustomer.zipCode) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _createVNode(_component_Button, {
                                          isGreen: true,
                                          isPrimary: true,
                                          class: "tw-p-0",
                                          icon: "check",
                                          type: "button",
                                          onClick: _ctx.saveBillingAddress,
                                          title: "Save billing address",
                                          "aria-label": "Save billing address"
                                        }, {
                                          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                            _createTextVNode(" Save ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_Button, {
                                          isRed: true,
                                          isSecondary: true,
                                          class: "tw-p-0",
                                          type: "button",
                                          onClick: _ctx.cancelBillingAddressEdit,
                                          title: "Cancel billing address edit",
                                          "aria-label": "Cancel billing address edit"
                                        }, {
                                          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                            _createTextVNode(" Cancel ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      (_ctx.billingAddress)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createVNode(_component_AddressBlock, {
                                              name: _ctx.customer.name,
                                              address: _ctx.customer.billingAddress
                                            }, null, 8, ["name", "address"]),
                                            _createElementVNode("button", {
                                              class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                              type: "button",
                                              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.startBillingAddressEdit && _ctx.startBillingAddressEdit(...args)))
                                            }, " Edit Billing Address ")
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "No billing address on file.", -1)),
                                            _createElementVNode("button", {
                                              class: "tw-mt-2 tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                                              type: "button",
                                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.startBillingAddressEdit && _ctx.startBillingAddressEdit(...args)))
                                            }, " Add Billing Address ")
                                          ]))
                                    ]))
                              ])
                            ])
                          ])
                        ]))
                      : (_ctx.activeTab === 'containers')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createVNode(_component_CustomerContainers, { customer: _ctx.customer }, null, 8, ["customer"])
                          ]))
                        : (_ctx.activeTab === 'rates')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createVNode(_component_CustomerRates, { customer: _ctx.customer }, null, 8, ["customer"])
                            ]))
                          : (_ctx.activeTab === 'contacts')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createVNode(_component_CustomerContacts, {
                                  customer: _ctx.customer,
                                  onUpdateCustomer: _ctx.refreshCustomer
                                }, null, 8, ["customer", "onUpdateCustomer"])
                              ]))
                            : (_ctx.activeTab === 'notes')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _createVNode(_component_AddNotesArea, {
                                    onAddedNote: _ctx.refreshCustomer,
                                    notes: _ctx.customer.notes,
                                    archivedNotes: _ctx.customer.archivedNotes,
                                    customer: _ctx.customer,
                                    type: "customer"
                                  }, null, 8, ["onAddedNote", "notes", "archivedNotes", "customer"])
                                ]))
                              : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "title", "onClose"]))
}